// TODO: make this file the main styles file to replace ./styles.tsx
import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_80,
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
  OL_COLOUR_BLACK_10,
  OL_COLOUR_NAVY_BABY,
  OL_COLOUR_BLACK_4,
} from '../../../Style/colours';
import { BREAKPOINT_MOBILE } from '../../../Style/breakpoints';

export const CommentContainer = styled('div')(
  (props: {
    indentLevel: number;
    pinned?: boolean;
    deleted?: boolean;
    linked: boolean;
    numTreeChildren: number;
  }) => ({
    position: 'relative',
    display:
      (props.pinned && props.deleted) ||
      (props.deleted && props.numTreeChildren === 0)
        ? 'none'
        : 'block',
    marginTop: !props.indentLevel ? '12px' : '2px',
    background: 'transparent',
    padding: '16px 0',
  })
);

export const CommentContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
});

export const CommentContentContainerLeftColumn = styled('div')({
  marginRight: 16,
});

export const CommentContentContainerRightColumn = styled('div')({
  flexGrow: 1,
});

export const CommentCard = styled('div')(
  (props: {
    indentLevel: number;
    pinned?: boolean;
    deleted?: boolean;
    linked: boolean;
  }) => ({
    backgroundColor: '#fff',

    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.25)',
    borderRadius: 4,

    padding: 8,

    hr: {
      border: 0,
      borderBottom: '1px solid #fff',
      borderTop: '1px solid #eee',
      margin: '20px 0',
    },
    [`@media(max-width: ${BREAKPOINT_MOBILE})`]: {
      marginLeft: props.indentLevel
        ? props.indentLevel > 6
          ? 6 * 10
          : props.indentLevel * 10
        : 0,
    },
    '&.collapsed': {
      cursor: 'pointer',
      minHeight: 44,
    },
    '&:focus': {
      boxShadow: ' 0 0 0 1px #fff,0 0 0 3px rgba(0,0,0,.55)',
      outline: '1px dotted rgba(0,0,0,.55)',
      outlineOffset: '-2px',
    },
  })
);

export const CommentProfilePicture = styled('img')({
  width: '40px',
  height: '40px',
  maxWidth: 'none',
  borderRadius: '50%',
  display: 'block',
  lineHeight: '1',

  [`@media (max-width: ${BREAKPOINT_MOBILE})`]: {
    width: '24px',
    height: '24px',
  },
});

export const CommentCardHeader = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const CommentAuthorName = styled('div')({
  color: OL_COLOUR_BLACK_90,
  fontSize: 14,
  flexGrow: 1,
});

export const CommentTimeSincePost = styled('div')({
  color: OL_COLOUR_BLACK_55,
  fontSize: 14,
  marginLeft: '1em',
});

export const CommentBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginLeft: '6px',
  flex: 1,
});

export const CommentHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '12px',
});

export const CommentProfileLink = styled('a')({
  color: OL_COLOUR_BLACK_80,
  fontWeight: 'bold',
  textDecoration: 'none',
});

export const CommentBadge = styled('span')(
  (props: { authorLevel?: string }) => ({
    color:
      props.authorLevel === 'admin'
        ? '#bb5757'
        : props.authorLevel === 'staff'
        ? '#8b8157'
        : '#578b61',
    marginLeft: '0.2em',
  })
);

export const CommentTimeStamp = styled('span')({
  color: OL_COLOUR_BLACK_55,
  marginLeft: '1em',
});

export const CommentReplyLikeInfo = CommentTimeStamp;

export const CommentContent = styled('div')(
  (props: {
    flagged?: boolean;
    deleted?: boolean;
    communityTagsEnabled?: boolean;
  }) => ({
    marginTop: '8px',
    marginBottom: '8px',
    padding: 0,
    fontSize: '14px',
    overflowWrap: 'anywhere',
    color: props.deleted ? '#888' : '#555',
    display: props.flagged ? 'none' : 'block',
    fontStyle: props.deleted ? 'italic' : 'normal',

    '&.collapsed': {
      margin: '8px 0 0 0',
      padding: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
      height: 18,
      color: '#555',
    },

    '.community-hashtag': props.communityTagsEnabled
      ? {
          padding: '8px 12px',
          background: OL_COLOUR_BLACK_4,
          borderRadius: 24,

          color: OL_COLOUR_NAVY_BABY,
          fontWeight: 600,
        }
      : {},
  })
);

export const CommentFooter = styled('div')({
  marginTop: 8,
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '12px',
});

export const CommentAttachmentsListItem = styled('li')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

export const AttachedImage = styled('img')({});

export const InappropriateAlert = styled('div')({
  marginTop: '14px',
  color: '#d77',
  cursor: 'pointer',
  padding: '8px 8px 8px 0',
});

export const SpoilerAlert = styled('div')({
  marginTop: '14px',
  color: '#b99',
  padding: '8px 8px 8px 0',
  '&:hover': {
    color: '#c77',
    cursor: 'pointer',
  },
});

export const CommentInResponseTo = styled('a')({
  color: OL_COLOUR_BLACK_55,
  fontSize: '14px',
  fontWeight: 600,
  marginLeft: 8,
  cursor: 'pointer',
  textDecoration: 'none',

  '&:hover': {
    color: OL_COLOUR_BLACK_55,
  },

  '.fa-comment-dots': {
    marginRight: 4,
  },
});

export const CommentFeaturedLine = styled('span')({
  color: OL_COLOUR_BLACK_55,
  whiteSpace: 'nowrap',
});

export const ReplyFormWrapper = styled('div')({
  marginTop: 16,
});

export const ShareTooltipHeading = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  '> *:first-child': {
    fontWeight: 800,
  },
  '> *:last-child': {
    fontSize: 11,
  },
});

export const PermalinkInput = styled('input')({
  border: 'none !important',
  width: '200px !important',
  height: '18px !important',
  fontSize: '12px !important',
  lineHeight: '16px !important',
  outline: 'none !important',
  boxShadow: 'none !important',
  WebkitBoxShadow: 'none !important',
  MozBoxShadow: 'none !important',
});

export const LinkedHereWrapper = styled('div')({
  padding: '16px 0',
});

export const LinkedHereSpan = styled('span')({
  fontSize: 14,
  fontWeight: 600,
});

export const ShareButtonWrapper = styled('div')({
  position: 'relative',
});

export const FeaturedCommentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',

  marginBottom: 16,
  paddingTop: 8,
  borderTop: `solid 1px ${OL_COLOUR_BLACK_10}`,

  '&, & button, & span': {
    fontSize: 14,
    fontWeight: 600,
  },
});

export const CommentRoleTitle = styled('span')({
  fontWeight: 600,
  padding: '2px 8px',
  margin: '0px 8px',
  color: OL_COLOUR_BLACK_55,
  borderRadius: '8px',
  background: OL_COLOUR_BLACK_4,
});
